/**
 * A time limit on the Supabase client's own auth calls (job #632).
 *
 * supabase-js sends the token refresh with no timeout, and every getSession()
 * waits behind it on the client's lock. On 21 Oct 2026 Tom's tab sent a refresh
 * at 15:04:11 that Supabase answered in 102 ms, the answer never reached the
 * tab, and for three minutes nothing in it got a token: Admin > Games sat on
 * "Loading…" without sending its request, until a reload. Bounding the call
 * turns a lost answer into a retryable error; supabase-js tries again inside
 * its own 30 s window and keeps the stored session if every try fails. Only
 * /auth/v1/ is bounded, at index.html's early-refresh budget; data reads keep
 * whatever signal their caller set.
 */
export const AUTH_CALL_MS = 5000

export function boundedAuthFetch(
  base: typeof fetch = (input, init) => fetch(input, init),
  ms: number = AUTH_CALL_MS,
): typeof fetch {
  return (input, init) => {
    const url = typeof input === 'string' ? input : input instanceof URL ? input.href : (input as Request).url
    if (!url.includes('/auth/v1/') || init?.signal || typeof AbortSignal?.timeout !== 'function') return base(input, init)
    return base(input, { ...init, signal: AbortSignal.timeout(ms) })
  }
}
